<template>
  <BLayoutView
    :back-route="backRoute"
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
    :save-menu-list="null"
  >
    <template #form>
      <ComponentForm
        ref="form"
        v-bind="viewTypeOptions"
        :data="viewTypeOptions.isCreate ? void 0 : single"
        :loading="isLoading"
        :editable="editable"
        :skeleton="isLoadingAsyncData"
        :link-visible="isLinkVisible"
        class="my-4"
        @save="onSave"
        @delete="onDelete(single)"
      >
        <template #save-menu>
          <v-row dense class="mt-4">
            <v-spacer />
            <v-col cols="auto">
              <BFormButtons
                :edit-route="editRoute"
                :loading="isLoading"
                :save-menu-list="saveMenuList"
                :skeleton="isLoadingAsyncData"

                :saveable="saveable"
                :editable="editable"
                :deletable="deletable"

                @delete="onDelete(single)"
                @save-menu="onSave"
              />
            </v-col>
          </v-row>
        </template>
      </ComponentForm>
    </template>
  </BLayoutView>
</template>

<script>
import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { createDeletableMixin } from '@/helpers/mixins/createDeletableMixin'
import { NotificationPageModel as Model } from './Model'
import { notificationPagesStoreModule as StoreModule } from './store'
import { NOTIFICATION_PAGES_ROUTES as ROUTES } from './utils'
import { VIEW, EDIT } from '@/helpers/enums/view-types'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import BFormButtons, { SAVE_MENUS } from '@/components/common/BFormButtons.vue'
import ComponentForm from './components/NotificationPagesForm.vue'


const mixinOptions = { Model, StoreModule, ROUTES }
const viewMixin = createViewMixin(mixinOptions)
const deletableMixin = createDeletableMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createViewMixin').ViewMixin<any, StoreModule> } View */
/** @typedef { import('@/helpers/mixins/createDeletableMixin').DeletableMixin<any, StoreModule> } Deletable */

export default {
  name: 'ViewPublicationsView',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BLayoutView,
    BFormButtons,
    ComponentForm,
  },
  mixins: [
    viewMixin,
    deletableMixin,
  ],
  data: () => ({
    backRoute: { name: ROUTES.LIST },
    saveMenuList: Object.values(SAVE_MENUS),
  }),
  computed: {
    isLinkVisible() {
      return [VIEW, EDIT].includes(this.viewType)
    },
    createRoute() {
      return {
        name: ROUTES.CREATE,
      }
    },
    editRoute() {
      return {
        name: ROUTES.EDIT,
        props: { id: this.id },
      }
    },
  },
  /** @type { View & Deletable } */
  methods: {
    async onSave(type) {
      const form = await this.$refs.form.onSubmit()
      form.url = form.url || form.id
      const result = await this.onSubmit(form)
      // this.$refs.form.onReset()

      const { id } = result
      const editRoute = { name: ROUTES.EDIT, params: { id } }
      this.toSave(this.backRoute, this.createRoute, editRoute, type)
    },
    async onDelete(data) {
      const result = await this.toDelete(data)
      if (!result) return
      this.$router.replace(this.backRoute)
    },
  },
}
</script>
